export default __webpack_public_path__ + "static/media/accept.b0bcfa82.svg";